import { BoneModal } from './BoneModal';

const cartClass = 'mini-cart';

const WCCheckout = (() => {

	const wcc = {
		submit: undefined,
		hasAjax: false,
		initialised: false,
		checkoutRoot: undefined,
		form: undefined,
		blockUIModal: undefined,
	}

	wcc.init = function() {
		const form = document.querySelector('form[name="checkout"]');
		if (!form) {
			return;
		}

		wcc.form = form;
		if (wcc.form) {
			$( wcc.form ).on( 'submit' , wcc.blockUI );
			$( document.body ).on( 'checkout_error' , wcc.unblockUI );
		}

		const billingPostcode = document.querySelector('input[name="billing_postcode"]');
		const shippingPostcode = document.querySelector('input[name="shipping_postcode"]');
		const billingState = document.querySelector('input[name="billing_state"]');
		const shippingState = document.querySelector('input[name="shipping_state"]');
		if(billingPostcode)
		{
			$(billingPostcode).on('focusout', $(document.body).trigger('update_checkout'));
		}
		if(billingState)
		{
			$(billingState).on('focusout', $(document.body).trigger('update_checkout'));
		}
		if(shippingPostcode)
		{
			$(shippingPostcode).on('focusout', $(document.body).trigger('update_checkout'));
		}
		if(shippingState)
		{
			$(shippingState).on('focusout', $(document.body).trigger('update_checkout'));
		}

		const root = document.querySelector('.wc-checkout');
		const submitButton = document.querySelector('.checkout-submit');

		if (root) {
			wcc.checkoutRoot = root;
		}

		wcc.submit = submitButton;
		// wcc.cart = cart;
		wcc.hasAjax = !! window.wc_checkout_params;

		// wc_ajax_url

		const applyCouponTrigger = document.querySelector('.checkout-apply-coupon-submit');
		if (applyCouponTrigger) {
			applyCouponTrigger.addEventListener('click', wcc._onRequestApplyCoupon);
		}

		wcc.setupLiveSummaries();
		wcc.setupShippingMethodConditionals();
	}


	wcc._onRequestApplyCoupon = function(e) {

		e.preventDefault();
		e.stopPropagation();

		if (!wcc.hasAjax) {
			// TODO: output an error message
			return;
		}

		const input = document.getElementById('apply-coupon-val');
		if (input) {
			const coupon = input.value;
			const url = window.wc_checkout_params.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon');

			$.ajax( {
				type:     'POST',
				url:      url,
				dataType: 'html',
				data: {
					coupon_code: coupon,
					security: window.wc_checkout_params.apply_coupon_nonce, // nonce here
				},
				success:  function( response ) {
					$('.checkout-apply-coupon-message').html(response);
				},
				complete: function(response) {
					console.log({response})
					// wcc.unblockUI();
				},
				error: function(response) {
					// console.log({response})
				},
			} );

		}
	}

	wcc.setupLiveSummaries = function() {
		if (wcc.checkoutRoot) {
			wcc.checkoutRoot.addEventListener('focusout', wcc._updateLiveSummaries, {passive: true});
		}
	}

	wcc.unloadLiveSummaries = function() {
		if (wcc.checkoutRoot) {
			wcc.checkoutRoot.removeEventListener('focusout', wcc._updateLiveSummaries);
		}
	}

	wcc._updateLiveSummaries = function(e) {
		// console.log('setting up live sumaryies')

		const summaryDisplays  = Array.from(document.querySelectorAll('[data-live-summary]'));
		const defaultSummary = '???';
		summaryDisplays.forEach(display => {

			const summaryKey = display.getAttribute('data-live-summary');
			let summary = '';
			switch(summaryKey)
			{
				case 'contact':
					summary = wcc._getContactSummary();
					break;
				case 'address':
					summary = wcc._getAddressSummary();
					break;
				case 'delivery_method':
					summary = wcc._getDeliveryMethodSummary();
					break;
				default:
					summary = defaultSummary;
			}

			display.innerHTML = summary || defaultSummary;
		})
	}

	/**
	 *
	 * @returns string
	 */
	wcc._getContactSummary = function() {
		const formData = new FormData(wcc.form);
		const email = formData.get('billing_email') || '';

		let summary = email || 'Email address missing';

		return summary;
	}

	/**
	 *
	 * @returns string
	 */
	wcc._getAddressSummary = function() {
		const errorMsg = 'Address fields missing';
		const formData = new FormData(wcc.form);
		const addr1 = formData.get('billing_address_1') || '';
		const country = 'Australia';
		const suburb = formData.get('billing_city') || '';
		const state = formData.get('billing_state') || '';
		const postcode = formData.get('billing_postcode') || '';
		const cityPieces = [suburb, state, postcode];

		if (!addr1 && !suburb && !postcode) {
			return errorMsg;
		}

		const cityString = cityPieces.reduce((carry, current) => {
			if (current) {
				const separator = carry ? ' ' : '';
				carry += separator + current;
			}

			return carry;
		}, '');

		const pieces = [addr1, cityString, country];
		const summary = pieces.reduce((carry, current) => {
			if (current) {
				const separator = carry ? ', ' : '';
				carry += separator + current;
			}

			return carry;
		}, '');

		return summary || errorMsg;
	}

	/**
	 *
	 * @returns string
	 */
	wcc._getDeliveryMethodSummary = function() {
		// return 'EXAMPLE delivery method';
		const formData = new FormData(wcc.form);
		const method = formData.get('delivery-method') || '';

		if (!method) {
			return 'Shipping fields missing';
		}

		if ('local_pickup' === method) {
			const showroom = formData.get('preferred-showroom') || '';
			return `Pick up in store &mdash; ${showroom}`;
		}

		if ('wf_australia_post' === method) {
			return 'Delivery';
		}

		return method;
	}

	// wcc.updateUI = function(fragments) {

	// 	if (fragments) {
	// 		Object.entries(fragments).forEach(entry => {
	// 			const [selector, fragment] = entry;
	// 			wcc.updateUIFragment(selector, fragment);
	// 		});
	// 	}

	// 	wcc.updateCartCount();
	// }

	// wcc.updateUIFragments = function(fragments) {
	// 	if (!fragments) {
	// 		return;
	// 	}

	// 	Object.entries(fragments).forEach(entry => {
	// 		const [selector, fragment] = entry;
	// 		wcc.updateUIFragment(selector, fragment);
	// 	});
	// }

	// wcc.updateUIFragment = function(selector, fragmentString) {
	// 	const containers = Array.from(document.querySelectorAll(selector));
	// 	if (containers && containers.length) {
	// 		containers.forEach(container => {
	// 			container.innerHTML = fragmentString;
	// 		});
	// 	}
	// }

	wcc.setupShippingMethodConditionals = function() {
		wcc.form.addEventListener('change', wcc.shippingMethodChangeDelegate);
	}

	wcc.shippingMethodChangeDelegate = function(e) {
		if (e.target.name !== 'delivery-method') {
			return;
		}

		const showroomSection = wcc.form.querySelector('.wc-checkout__section--select-showroom');
		if (!showroomSection) {
			return;
		}

		const wooShippingRadios = document.querySelectorAll('input.shipping_method');
		const selectedValue = e.target.value;
		if( wooShippingRadios )
		{
			wooShippingRadios.forEach((item) => {
				if( item.value.toString().includes(selectedValue) )
				{
					item.setAttribute('checked', 'checked');
				}
				else
				{
					item.removeAttribute('checked');
				}
			});
		}

		if ('local_pickup' === e.target.value && e.target.checked) {
			showroomSection.removeAttribute('disabled');

		}
		else {
			showroomSection.setAttribute('disabled', 'true');
		}

		$('body').trigger('update_checkout');
	}

	wcc.unloadShippingMethodConditionals = function() {
		wcc.form.removeEventListener('change', wcc.shippingMethodChangeDelegate);
	}

	wcc.blockUI = function() {
		if (!wcc.blockUIModal) {
			const elem = document.querySelector('.checkout-block-ui-modal');
			const modal = new BoneModal(elem);
			wcc.blockUIModal = modal;
		}

		if (wcc.blockUIModal) {
			wcc.blockUIModal.open();
		}
	}

	wcc.unblockUI = function() {
		if (wcc.blockUIModal) {
			console.log('opening closing modal')
			wcc.blockUIModal.close();
		}
	}

	wcc.unload = function() {
		wcc.unloadShippingMethodConditionals();
	}

	return wcc;
})();

export default WCCheckout;



// WEBPACK FOOTER //
// ./scripts/modules/wc-checkout.js